var enhanceData = function (results) {
  return results.map(function (i) {
    i._showDetails = false
    i.isDetails = false
    i.isEdit = false
    return i
  })
}

export const ListMixin = {
  data () {
    return {
      searchQuery: null,
      currentPage: 1,
      rowsTotal: 0,
      context: {rowsPerPage: 10},
      perPage: 10,
      perPageOptions: [5, 10, 25, 50]
    }
  },
  methods: {
    showDetails (item) {
      item.isDetails = true
      item.isEdit = false
      item._showDetails = true
    },
    showEdit (item) {
      item.isDetails = false
      item.isEdit = true
      item._showDetails = true
    },
    hideData (item) {
      item.isDetails = false
      item.isEdit = false
      item._showDetails = false
    },
    prepareParams () {
      let params = {}
      let ctx = this.context
      if (ctx.sortBy) {
        params['ordering'] = (ctx.descending ? '-' : '') + ctx.sortBy
      }
      if (ctx.rowsPerPage) {
        params['page_size'] = ctx.rowsPerPage
      }
      if (ctx.page) {
        params['page'] = ctx.page
      }
      if (ctx.searchQuery) {
        params['search'] = ctx.searchQuery
      }
      return params
    },
    enhanceListData (data) {
      var items = enhanceData(data.results)
      this.rowsTotal = data.count
      return items
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ListMixin.js